import React from 'react';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../contexts/LanguageContext';

const dealerItemTemplate = (option) => {
    if (!option) return null;

    if (option.isBulkOption) {
        return <div className="font-bold border-bottom-1 surface-border pb-2 mb-1">{option.name}</div>;
    }

    return <div>{option.name}</div>;
};

const PartsDealerBrandMatchForm = ({
    visible,
    onHide,
    selectedDealerIds,
    onDealerChange,
    dealerOptions,
    isDealerDropdownLoading,
    onDealerFilter,
    selectedBrands,
    onBrandChange,
    brandOptions,
    isBrandDropdownLoading,
    onBrandFilter,
    isVisible,
    onVisibilityChange,
    visibilityOptions,
    isLookupEmpty,
    isLookupLoading,
    onSave,
    isSaving,
    submitted
}) => {
    const { th } = useLanguage();
    const saveDisabled = isSaving || isLookupEmpty || isLookupLoading;

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button type="button" label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} />
            <Button type="button" label={th('common.save')} icon="pi pi-save" onClick={onSave} loading={isSaving} disabled={saveDisabled} />
        </div>
    );

    return (
        <Dialog header={th('partsDealerBrandMatch.title')} visible={visible} style={{ width: '45vw' }} modal footer={footer} onHide={onHide} className="p-fluid">
            <div className="formgrid grid">
                <div className="field col-12 md:col-4">
                    <label htmlFor="pdbm-dealer" className="font-bold">
                        {th('partsDealerBrandMatch.dealerSelection')}
                    </label>
                    <MultiSelect
                        id="pdbm-dealer"
                        value={selectedDealerIds}
                        options={dealerOptions}
                        onChange={(e) => onDealerChange(e.value || [])}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        filterBy="name,dealerName,sapDealerId,value"
                        onFilter={onDealerFilter}
                        display="chip"
                        showClear
                        showSelectAll={false}
                        placeholder={th('partsDealerBrandMatch.dealerSearchPlaceholder')}
                        className={`w-full ${submitted && !selectedDealerIds?.length ? 'p-invalid' : ''}`}
                        loading={isDealerDropdownLoading}
                        itemTemplate={dealerItemTemplate}
                        emptyFilterMessage={th('common.noRecords')}
                        maxSelectedLabels={3}
                        selectedItemsLabel={th('common.selectedCount', { count: selectedDealerIds?.length || 0 })}
                    />
                    {submitted && !selectedDealerIds?.length && <small className="p-error">{th('partsDealerBrandMatch.requiredDealer')}</small>}
                </div>

                <div className="field col-12 md:col-4">
                    <label htmlFor="pdbm-brand" className="font-bold">
                        {th('partsDealerBrandMatch.brandSelection')}
                    </label>
                    <MultiSelect
                        id="pdbm-brand"
                        value={selectedBrands}
                        options={brandOptions}
                        onChange={(e) => onBrandChange(e.value || [])}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        filterBy="name,value"
                        onFilter={onBrandFilter}
                        display="chip"
                        showClear
                        placeholder={th('partsDealerBrandMatch.brandSearchPlaceholder')}
                        className={`w-full ${submitted && !selectedBrands?.length ? 'p-invalid' : ''}`}
                        loading={isBrandDropdownLoading}
                        emptyFilterMessage={th('common.noRecords')}
                        maxSelectedLabels={3}
                        selectedItemsLabel={th('common.selectedCount', { count: selectedBrands?.length || 0 })}
                    />
                    {submitted && !selectedBrands?.length && <small className="p-error">{th('partsDealerBrandMatch.requiredBrand')}</small>}
                </div>

                <div className="field col-12 md:col-4">
                    <label htmlFor="pdbm-visibility" className="font-bold">
                        {th('partsDealerBrandMatch.visibility')}
                    </label>
                    <Dropdown
                        id="pdbm-visibility"
                        value={isVisible}
                        options={visibilityOptions}
                        onChange={(e) => onVisibilityChange(e.value)}
                        optionLabel="label"
                        optionValue="value"
                        placeholder={th('partsDealerBrandMatch.visibility')}
                        className={`w-full ${submitted && (isVisible === null || isVisible === undefined) ? 'p-invalid' : ''}`}
                        disabled={isLookupEmpty || isLookupLoading}
                        loading={isLookupLoading}
                        showClear
                    />
                    {isLookupEmpty && <small className="p-error">{th('partsDealerBrandMatch.visibilityLookupEmpty')}</small>}
                    {submitted && !isLookupEmpty && (isVisible === null || isVisible === undefined) && <small className="p-error">{th('partsDealerBrandMatch.requiredVisibility')}</small>}
                </div>
            </div>
        </Dialog>
    );
};

export default PartsDealerBrandMatchForm;
